module.exports = __webpack_public_path__ + "img/filing_icon.d0289dc0.png";